export const breakpoints = <const>{
  sm: 569,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
};

export type Breakpoint = keyof typeof breakpoints;